var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGolden({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#2A7DE1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.533 -642.467)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 86,
    height: 86,
    rx: 12,
    transform: "translate(-58.533 642.467)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M3,38.916H31.733V3H3ZM3,67.649H31.733V46.1H3Zm35.916,0H67.649V31.733H38.916ZM38.916,3V24.55H67.649V3Z",
    transform: "translate(-50.368 650.632)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolden);
export default __webpack_public_path__ + "static/media/golden.f1f78d8f480db456e5ee58fff5748471.svg";
export { ForwardRef as ReactComponent };